<template>
<div class="" style="background:#f6f6f6;overflow:hidden;" :style="{minHeight:getHeight+'px'}">
    <div class="personal-bg">
        智慧园区数据生态服务商
    </div>
    <div class="personal-cont">
        <div class="left-cont">
            <div class="title">
                <i class="iconfont icon-app_icons--"></i>个人中心
            </div>
            <ul class="list-cont">
                <li v-for="(item,index) in listName" :key="index" class="list" :class="show == index?'active':''" @click="tabsItem(index)">{{item}}</li>
            </ul>
        </div>
        <div class="right-cont">
            <div :class="show === 0?'item-show':''" class="item-cont">
                <div class="avatar-cont">
                    <div class="avatar">
                        <img :src="user.imgHead" alt="头像">
                    </div>
                    <div class="text-operate">
                        <div v-if="!isRevise" class="text">
                            <span>Hi,{{user.name}}</span>
                            <span class="icon-p" @click="reviseParkName"><i class="el-icon-edit-outline"></i></span>
                        </div>
                        <div v-else class="revise-input">
                            <el-input v-model="user.name" size="medium" style="width:300px;"></el-input>
                            <el-button type="primary" size="medium" @click="confirmRevise">确 认</el-button>
                        </div>
                        <div class="revise">
                            <el-upload ref="upload" :action="$config.imgUpload+'/Api/UploadImg'" :on-success="onSuccess" :before-upload="beforeAvatarUpload" :headers="headers" accept=".jpg,.jpeg ,.png" :auto-upload="true" :limit="1" :on-remove="handleRemove" :file-list="user.fileList">
                                <button class="uploadAvatar">修改头像</button>
                            </el-upload>
                        </div>
                        <!-- <div class="revise">
                            <el-input placeholder="请输入旧密码" auto-complete="new-password" v-model="user.oldPwd" show-password style="width:300px"></el-input>
                        </div>
                        <div class="revise">
                            <el-input placeholder="请输入新密码" auto-complete="new-password" v-model="user.newPwd" show-password style="width:300px"></el-input>
                        </div>
                        <div class="revise">
                            <el-input placeholder="请再次输入新密码" auto-complete="new-password" v-model="user.newPwd2" show-password style="width:300px"></el-input>
                        </div>
                        <div class="revise">
                            <el-button type="primary" @click="onUploadSubmit">保存</el-button>
                        </div> -->
                    </div>
                </div>
                <div class="revise-pass">
                    <div class="text">修改密码</div>
                    <el-form :model="user" status-icon :rules="rules" ref="ruleForm" label-width="84px" class="demo-ruleForm">
                        <el-form-item label="手机号：" prop="phone">
                            <el-input v-model="user.phone" autocomplete="off" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码：">
                            <el-input placeholder="请输入验证码" v-model="user.code" style="width:64%;"></el-input>
                            <el-button type="primary" :disabled="disabled=!btnshow" class="vercode">
                                <span v-show="btnshow" @click.stop="getVeriCode('ruleForm',4)">获取验证码</span>
                                <span v-show="!btnshow" class="count" style="color: #fff;">{{count}} s</span>
                            </el-button>
                        </el-form-item>
                        <!-- <el-form-item label="当前密码：" prop="nowpass">
                            <el-input type="password" v-model="ruleForm.nowpass" autocomplete="off"></el-input>
                        </el-form-item> -->
                        <el-form-item label="新密码：" prop="newPwd">
                            <el-input type="password" v-model="user.newPwd" autocomplete="off" placeholder="请输入新密码"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码：" prop="newPwd2">
                            <el-input type="password" v-model="user.newPwd2" autocomplete="off" placeholder="再次输入新密码"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="updatePass('ruleForm')">提交</el-button>
                            <el-button @click="resetForm('ruleForm')">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div :class="show === 1?'item-show':''" class="item-cont">
                <mycollect :todo="todo"></mycollect>
            </div>
            <div :class="show === 2?'item-show':''" class="item-cont">3</div>
            <div :class="show === 3?'item-show':''" class="item-cont">4</div>
        </div>
    </div>
</div>
</template>

<script>
const TIME_COUNT = 60; //更改倒计时时间
import qs from "qs";
import {
    mapMutations
} from "vuex";
import {
    getRequestCode,
    AutoLogin,
    checkToken,
    userOutLogin,
    userLogin,
    getUserBaseInfo,
    getVeriCode,
    verificationCode,
    forgetUserPwd,
    changeUserPwd,
    changeUserName
} from "../../api/api.js";
import mycollect from "./mycollect.vue";
export default {
    name: "",
    data() {
        var nowPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入当前密码'));
            } else {
                if (this.user.newPwd !== '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入新密码'));
            } else {
                if (this.ruleForm.checkPass !== '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请再次输入新密码'));
            } else if (value != this.user.newPwd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("手机号不能为空"));
            }
            if (!(/^1[3456789]\d{9}$/.test(value))) {
                return callback(new Error("请输入正确的手机号"));
            } else {
                return callback();
            }
        };
        return {
            loading: false,
            //验证码按钮
            btnshow: true, // 初始启用按钮
            count: "", // 初始化次数
            timer: null,
            show: 0,
            listName: ['我的账号', '我的收藏'], //['我的账号', '我的收藏', '购买套餐', '申请开票'],
            parkInfo: {
                src: require("../../assets/images/park-avatar.png"),
                name: "F518时尚创意园"
            },
            isRevise: false,
            ruleForm: {
                pass: '',
                checkPass: '',
                nowpass: '',
                verificationCode: ''
            },
            rules: {
                newPwd: [{
                    validator: validatePass,
                    trigger: 'blur'
                }],
                newPwd2: [{
                    validator: validatePass2,
                    trigger: 'blur'
                }],
                nowpass: [{
                    validator: nowPass,
                    trigger: 'blur'
                }],
                phone: [{
                    validator: checkPhone,
                    trigger: "blur"
                }],
            },
            activeName: 'first',
            getHeight: 0,
            collectPark: [{
                name: 'CTEC中国（长沙）工程机械产业园1',
                type: '工业园区',
                address: '深圳市福田区车公庙',
                collect: false
            }],
            collectScreen: [{
                imgUrl: require("../../assets/images/example1.png"),
                name: 'F518创意园1',
                collect: false
            }],
            user: {
                name: '',
                imgHead: '',
                phone: '',
                code: '',
                newPwd: '',
                newPwd2: '',
                fileList: []
            },
            headers: {
                Token: ''
            },
            todo:1
        };
    },
    components: {
        mycollect
    },
    watch: {
        getHeight: {
            handler(newVal, oldVal) {
                return newVal
            }
        },
        deep: true
    },
    created() {
        this.toLogin();
    },
    mounted() {
        this.getHeight = `${document.documentElement.clientHeight}`;
        let _this = this
        window.onresize = () => {
            return (() => {
                window.getHeight = document.documentElement.clientHeight
                _this.getHeight = window.getHeight
            })()
        }

    },
    methods: {
        ...mapMutations([
            "parkLogin",
            "parkName",
            "parkType",
            "parkMenuid",
            "parkTokentime",
            "updateTokenStatus"
        ]),
        //获取数据
        loadData: function () {
            let _this = this;
            _this.loading = true;
            let result1 = _this.getUserInfo();
            Promise.all([result1]).then(res => {
                _this.loading = false;
            });
            _this.headers.Token = localStorage.getItem('parkToken');
        },
        getUserInfo() {
            let _this = this;
            // _this.loading = true;
            return new Promise((resolve, reject) => {
                let StrJson = {};
                let params = {
                    StrJson: JSON.stringify(StrJson)
                };
                getUserBaseInfo(params)
                    .then(function (response) {
                        let res = response.data;
                        let jsonData = [];
                        if (res.code == 1) {
                            _this.user = {
                                name: res.data.name,
                                imgHead: res.data.imgHead,
                                oldPwd: '',
                                newPwd: '',
                                newPwd2: '',
                                fileList: []
                            }
                        }
                        resolve(resolve);
                    })
                    .catch(function (error) {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        toLogin() {
            let _this = this;
            let code = this.$route.query.code;
            let token = localStorage.getItem('parkToken');
            if (code && !token) {
                // _this.loading = true;
                let result = _this.login(code);
                Promise.all([result]).then(res => {
                    setTimeout(() => {
                        _this.loadData();
                        _this.todo = 2;
                    }, 100);
                });
            } else {
                let params = {
                    Code: token,
                    UrlCode: code
                };
                checkToken(params)
                    .then(function (response) {
                        let res = response.data;
                        if (res.code == 1) {
                            var result = res.data.result;
                            if (result == 1) {
                                _this.del_User(1);
                            }
                            if (result == 2) {
                                _this.loadData();
                                _this.todo = 2;
                            }
                            if (result == 3) {
                                //console.log('进入3');
                                Promise.all([_this.del_User(2)]).then(res => {
                                    setTimeout(() => {
                                        let result = _this.login(code);
                                        Promise.all([result]).then(res => {
                                            setTimeout(() => {
                                                _this.loadData();
                                                _this.todo = 2;
                                            }, 100);
                                        });
                                    }, 100);
                                });
                            }
                        } else {
                            _this.commonTipsError("授权失败");
                            _this.loadData();
                            _this.todo = 2;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        _this.loadData();
                        _this.todo = 2;
                    });

                // this.loadData();
                // this.getcollect();
            }
        },
        del_User(type) {
            let _this = this;
            return new Promise((resolve, reject) => {
                let params = {};
                userOutLogin(params)
                    .then(function (response) {
                        let res = response.data;
                        if (res.code == 1 || res.code == -2) {
                            localStorage.removeItem("parkToken");
                            localStorage.removeItem("parkusername");
                            localStorage.removeItem("parktype");
                            localStorage.removeItem("parkmenuid");
                            localStorage.removeItem("parkTokenTime");
                            if (type === 1) {
                                window.location.href = _this.$config.Home.pageUrl + '/login';
                            }
                        } else {
                            _this.commonTipsError(res.result);
                        }
                        resolve(resolve);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            });
        },
        login(code) {
            let _this = this;
            return new Promise((resolve, reject) => {
                let params = {
                    Code: code
                };
                AutoLogin(params)
                    .then(function (response) {
                        let res = response.data;
                        if (res.code == 1) {
                            let loginToken = res.data.loginToken;
                            let name = res.data.name;
                            _this.parkLogin({
                                parkToken: loginToken
                            });
                            _this.parkName({
                                parkusername: name
                            });

                            //alert(localStorage.getItem('parkbigscreenToken'))
                            _this.updateTokenStatus(true);
                            //window.location.href = "/bigScreen?id=" + id;

                        }
                        resolve(resolve);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        },
        tabsItem(index) {
            this.show = index;
        },
        handleAvatarSuccess(res, file) {
            this.parkInfo.src = URL.createObjectURL(file.raw);
        },
        reviseParkName() {
            this.isRevise = true;
        },
        confirmRevise() {
            let _this = this;
            let StrJson = {
                Name: _this.user.name,
            };
            let params = {
                StrJson: JSON.stringify(StrJson)
            }
            _this.loading = true;
            changeUserName(params)
                .then(function (response) {
                    let res = response.data;
                    if (res.code == 1) {
                        _this.commonTipsSuccess("修改成功,重新登录后生效");
                        _this.isRevise = false;
                        _this.getUserInfo();
                    }
                    _this.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        //上传图片
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        beforeAvatarUpload(file) {
            console.log(file);
            let isJPG = file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/png';
            let isLt2M = file.size / 1024 / 1024 < 0.5;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG或者Png 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 500KB!');
            }
            return isJPG && isLt2M;
        },
        onSuccess(response, file, fileList) {
            console.log(response);
            if (response.code == 1) {
                this.$message.success('头像更换成功');
                this.getUserInfo();
            } else {
                this.$message.error('上传失败');
            }
            this.user.fileList = [];
        },
        //获取验证码
        getVeriCode(formName, Type) {
            let _this = this;
            if (_this.user.phone && (/^1[3456789]\d{9}$/.test(_this.user.phone))) {
                let params = {
                    Phone: _this.user.phone,
                    Type: Type
                };
                _this.loading = true;
                getVeriCode(params)
                    .then(function (response) {
                        let res = response.data;
                        if (res.code == 1) {
                            _this.send(formName);
                            _this.commonTipsSuccess("短信发送成功，请注意查收");
                            _this.loading = false;
                        }
                        _this.loading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            } else {
                this.$message.error('请填写正确的手机号');
            }
        },
        send(formName) {
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.btnshow = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.btnshow = true;
                        clearInterval(this.timer); // 清除定时器
                        this.timer = null;
                    }
                }, 1000);
            }
        },
        //根据手机号，验证码修改密码
        updatePass(formName) {
            let _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        Phone: _this.user.phone,
                        Code: _this.user.code,
                        PassWord: _this.user.newPwd,
                        Type: 4
                    };
                    // let params = {
                    //     StrJson: JSON.stringify(StrJson)
                    // }
                    _this.loading = true;
                    changeUserPwd(params)
                        .then(function (response) {
                            let res = response.data;
                            if (res.code == 1) {
                                _this.commonTipsSuccess("修改成功");
                                _this.resetForm('ruleForm');
                            }
                            _this.loading = false;
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                } else {
                    return false;
                }
            });
        },

    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/index/personalcenter.vue